import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({progress}) => {
	return (
		<div className="ProgressBar">
			<div className="ProgressBar-progress" style={{width: Math.round(progress) + '%'}} />
		</div>
	);
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/widgets/ProgressBar.js